export const createEntitySyncHandler = ({
  localRepository,
  remoteRepository,
  getScope,
}) => ({
  async sync(syncOperation) {
    if (syncOperation.operation === "delete") {
      await remoteRepository.deleteEntity(
        syncOperation.entityId,
        getScope(syncOperation)
      );
      return;
    }

    const entity = await localRepository.getById(syncOperation.entityId);

    if (!entity) {
      throw new Error(
        `Local entity ${syncOperation.entityType}:${syncOperation.entityId} not found`
      );
    }

    await remoteRepository.upsertEntity(entity, getScope(syncOperation, entity));
  },
});
